import request from "@/router/axios";

// 新增巡检计划
export const add = (row) => {
  return request({
    url: "/api/produce/inspection-plan/insert",
    method: "post",
    data: row,
  });
};

// 更新巡检计划
export const update = (row) => {
  return request({
    url: "/api/produce/inspection-plan/update",
    method: "post",
    data: row,
  });
};

// 获取巡检计划详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/inspection-plan/select/id",
    method: "get",
    params: {
      id,
    },
  });
};

// 获取巡检计划列表
export const getList = (data) => {
  return request({
    url: "/api/produce/inspection-plan/select/page",
    method: "post",
    data,
  });
};

// 删除巡检计划
export const exportExcel = (data) => {
  return request({
    url: "/api/produce/inspection-plan/export/excel",
    method: "post",
    data,
    responseType: "blob",
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/produce/inspection-plan/delete/ids",
    method: "get",
    params: {
      ids,
    },
  });
};

// 批量更新状态
export const updateStatusBatch = (data) => {
  return request({
    url: "/api/produce/inspection-plan/update/status/batch",
    method: "post",
    params: {
      ids: data.ids,
      status: data.status,
    },
  });
};


// 获取巡检路线列表
export const getRouteList = (params = {}) => {
  return request({
    url: "/api/produce/inspection-route/select/page",
    method: "post",
    data: params,
  });
};
